const moduleRoutes = [
    {
        path: '/capacity',
        name: 'capacity',
        children: [
            {
                path: '',
                name: 'Capacity',
                component: () => import('@/modules/capacity/list/List.vue'),
                meta: {
                    resource: 'capacities',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Capacity',
                    breadcrumbs: [{ title: 'MCU Booking', routeName: 'capacity' }]
                }
            }
        ]
    }
]

export default moduleRoutes
